/* eslint-disable */
import { Box, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import useStyles from '../../Main.style';
import {
  customSortHelper,
  formatToCurrency,
  formatToNumber,
  getLoggedInUserData,
  getRankingClass,
  getMaxVectorRank,
} from '../../../../utils/Helper';

const SummaryInvoiceByCell = ({
  reportArr,
  myCellInvoiceArray,
  myProfitRevenue,
  dashboardComments,
  dashboardSectionText,
  onCommentUpdate,
  cellReportData,
}) => {
  const classes = useStyles();
  const [pastDueInvoicesObject, setPastDueInvoicesObject] = useState([]);
  const [profitInvoicesObject, setProfitInvoicesObject] = useState([]);
  const [revenueInvoicesObject, setRevenueInvoicesObject] = useState([]);
  const loggedInUserData = getLoggedInUserData();
  const [cellDetails] = useState(loggedInUserData['cell']);

  const fillPastDueTotals = useCallback(async (reportArr) => {
    reportArr.sort((a, b) => {
      const totalA = parseFloat(a.totalDue);
      const totalB = parseFloat(b.totalDue);

      if (totalA > totalB) {
        return -1;
      }
      if (totalA < totalB) {
        return 1;
      }
      return 0;
    });
    //Ranking logic for past due
    let rankingIncr = 0;
    reportArr.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        rankingIncr = rankingIncr + 1;
        obj.rank = rankingIncr;
      }
    });

    //Ranking logic
    setPastDueInvoicesObject(reportArr);
  });

  const fillProfit = async ({ reportArr }) => {
    reportArr.sort((a, b) => {
      const totalA = parseFloat(a.profit);
      const totalB = parseFloat(b.profit);

      if (totalA > totalB) {
        return -1;
      }
      if (totalA < totalB) {
        return 1;
      }
      return 0;
    });
    //Ranking logic for past due
    let rankingIncr = 0;
    reportArr.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        rankingIncr = rankingIncr + 1;
        obj.rank = rankingIncr;
      }
    });
    //Ranking logic
    setProfitInvoicesObject(reportArr);
  };

  const fillRevenue = async ({ reportArr }) => {
    reportArr.sort((a, b) => {
      const totalA = parseFloat(a?.revenue);
      const totalB = parseFloat(b?.revenue);

      if (totalA > totalB) {
        return -1;
      }
      if (totalA < totalB) {
        return 1;
      }
      return 0;
    });
    //Ranking logic for past due
    let rankingIncr = 0;
    reportArr.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        rankingIncr = rankingIncr + 1;
        obj.rank = rankingIncr;
      }
    });
    //Ranking logic
    setRevenueInvoicesObject(reportArr);
  };

  useEffect(() => {
    fillPastDueTotals(reportArr);
  }, [fillPastDueTotals, reportArr]);

  useEffect(() => {
    fillRevenue({ reportArr });
  }, []);

  useEffect(() => {
    fillProfit({ reportArr });
  }, []);

  return (
    <>
      <Box mt={1}>
        <MaterialTable
          style={{ boxShadow: 'none' }}
          isLoading={myCellInvoiceArray.length === 0 ? true : false}
          options={{
            toolbar: false,
            draggable: false,
            paging: false,
            sorting: true,
            pageSize: 20,
            pageSizeOptions: [10, 20, 50, 100],
            showTextRowsSelected: false,
            toolbarButtonAlignment: 'right',
            showFirstLastPageButtons: false,
            actionsColumnIndex: -100,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            pagination: {
              labelRowsSelect: 'Rows',
              labelRowsPerPage: 'Rows Per Page',
            },
          }}
          title="Invoicing"
          columns={[
            {
              title: 'Cell ' + cellDetails?.['cellTitle'],
              sorting: false,
              field: 'cellf',
            },
            {
              title: new Date().getFullYear() + ' YTD',
              field: 'ytd',
              width: '15%',
              customSort: (a, b) => customSortHelper(a, b, 'ytd1'),
            },
            {
              title: 'Ranking',
              field: 'vectorranking',
              width: '15%',
              customSort: (a, b) => customSortHelper(a, b, 'vectorranking'),
              render: (rowData) => (
                <Box display="flex" justifyContent="center">
                  <span
                    className={getRankingClass(
                      rowData?.vectorranking,
                      getMaxVectorRank(myCellInvoiceArray, 'vectorranking'),
                      classes,
                    )}
                  >
                    {rowData?.vectorranking}
                  </span>
                </Box>
              ),
            },
            {
              title: 'Top Cell',
              field: 'bestcell',
              width: '15%',
              customSort: (a, b) => customSortHelper(a, b, 'bestCell1'),
            },
            {
              title: 'Last Year',
              field: 'previousyear',
              width: '15%',
              customSort: (a, b) => customSortHelper(a, b, 'previousYear1'),
            },
          ]}
          data={[
            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Revenue"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),

              ytd: formatToCurrency(myCellInvoiceArray[6]?.ytd, classes),
              ytd1: myCellInvoiceArray[6]?.ytd,
              vectorranking: myCellInvoiceArray[6] ? myCellInvoiceArray[6]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[6]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[6]?.bestCell,
              previousyear: formatToCurrency(myCellInvoiceArray[6]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[6]?.prevYear,
            },
            {
              //Revenue Target data
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Revenue Target"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),

              ytd: formatToCurrency(myCellInvoiceArray[0]?.ytd, classes),
              ytd1: myCellInvoiceArray[0]?.ytd,
              vectorranking: myCellInvoiceArray[0] ? myCellInvoiceArray[0]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[0]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[0]?.bestCell,
              previousyear: formatToCurrency(myCellInvoiceArray[0]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[0]?.prevYear,
            },
            {
              //Revenue Target data
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Revenue Target (Accumulated)"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),

              ytd: formatToCurrency(myCellInvoiceArray[9]?.ytd, classes),
              ytd1: myCellInvoiceArray[9]?.ytd,
              vectorranking: myCellInvoiceArray[9] ? myCellInvoiceArray[9]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[9]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[9]?.bestCell,

              previousyear: formatToCurrency(myCellInvoiceArray[9]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[9]?.prevYear,
            },
            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Gross Profit"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd: formatToCurrency(myCellInvoiceArray[7]?.ytd, classes),
              ytd1: myCellInvoiceArray[7]?.ytd,
              vectorranking: myCellInvoiceArray[7] ? myCellInvoiceArray[7]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[7]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[7]?.bestCell,

              previousyear: formatToCurrency(myCellInvoiceArray[7]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[7]?.prevYear,
            },
            {
              //Gross Profit Target
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Gross Profit Target"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),

              ytd: formatToCurrency(myCellInvoiceArray[1]?.ytd, classes),
              ytd1: myCellInvoiceArray[1]?.ytd,
              vectorranking: myCellInvoiceArray[1] ? myCellInvoiceArray[1]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[1]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[1]?.bestCell,

              previousyear: formatToCurrency(myCellInvoiceArray[1]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[1]?.prevYear,
            },
            {
              //Average Gross Profit per File
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Average Gross Profit per File"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd: formatToCurrency(myCellInvoiceArray[5]?.ytd, classes, ' /File'),
              ytd1: myCellInvoiceArray[5]?.ytd,
              vectorranking: myCellInvoiceArray[5] ? myCellInvoiceArray[5]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[5]?.bestCell, classes, ' /File'),
              bestCell1: myCellInvoiceArray[5]?.bestCell,

              previousyear: formatToCurrency(myCellInvoiceArray[5]?.prevYear, classes, ' /File'),
              previousYear1: myCellInvoiceArray[5]?.prevYear,
            },
            {
              //Average Gross Profit per File
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Gross Profit Target (Accumulated)"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd: formatToCurrency(myCellInvoiceArray[10]?.ytd, classes),
              ytd1: myCellInvoiceArray[10]?.ytd,
              vectorranking: myCellInvoiceArray[10]?.vectorRank,

              bestcell: formatToCurrency(myCellInvoiceArray[10]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[10]?.bestCell,

              previousyear: formatToCurrency(myCellInvoiceArray[10]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[10]?.prevYear,
            },
            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Gross Profit Weighted for Complexity"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd: formatToCurrency(myCellInvoiceArray[8]?.ytd, classes),
              ytd1: myCellInvoiceArray[8]?.ytd,

              vectorranking: myCellInvoiceArray[8] ? myCellInvoiceArray[8]?.vectorRank : '',

              bestcell: formatToCurrency(myCellInvoiceArray[8]?.bestCell, classes),
              bestCell1: myCellInvoiceArray[8]?.bestCell,

              previousyear: formatToCurrency(myCellInvoiceArray[8]?.prevYear, classes),
              previousYear1: myCellInvoiceArray[8]?.prevYear,
            },
            {
              //Active to Admin Delta

              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Active to Admin Delta"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd:
                myCellInvoiceArray[3]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[3]?.ytd, classes)
                  : formatToNumber(
                      myCellInvoiceArray[3]?.ytd,
                      classes,
                      myCellInvoiceArray[3]?.type,
                    ),
              ytd1: myCellInvoiceArray[3]?.ytd,
              vectorranking: myCellInvoiceArray[3]?.vectorRank,
              bestcell:
                myCellInvoiceArray[3]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[3]?.bestCell, classes)
                  : formatToNumber(
                      myCellInvoiceArray[3]?.bestCell,
                      classes,
                      myCellInvoiceArray[3]?.type,
                    ),
              bestCell1: myCellInvoiceArray[3]?.bestCell,
              previousyear:
                myCellInvoiceArray[3]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[3]?.prevYear, classes)
                  : formatToNumber(
                      myCellInvoiceArray[3]?.prevYear,
                      classes,
                      myCellInvoiceArray[3]?.type,
                    ),
              previousYear1: myCellInvoiceArray[3]?.prevYear,
            },
            {
              //Admin to Closed Delta
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Admin to Closed Delta"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd:
                myCellInvoiceArray[4]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[4]?.ytd, classes)
                  : formatToNumber(
                      myCellInvoiceArray[4]?.ytd,
                      classes,
                      myCellInvoiceArray[4]?.type,
                    ),
              ytd1: myCellInvoiceArray[4]?.ytd,
              vectorranking: myCellInvoiceArray[4]?.vectorRank,
              bestcell:
                myCellInvoiceArray[4]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[4]?.bestCell, classes)
                  : formatToNumber(
                      myCellInvoiceArray[4]?.bestCell,
                      classes,
                      myCellInvoiceArray[4]?.type,
                    ),
              bestCell1: myCellInvoiceArray[4]?.bestCell,
              previousyear:
                myCellInvoiceArray[4]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[4]?.prevYear, classes)
                  : formatToNumber(
                      myCellInvoiceArray[4]?.prevYear,
                      classes,
                      myCellInvoiceArray[4]?.type,
                    ),
              previousYear1: myCellInvoiceArray[4]?.prevYear,
            },
            {
              //Optimal Invoice Delta
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Optimal Invoice Delta"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd:
                myCellInvoiceArray[2]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[2]?.ytd, classes)
                  : formatToNumber(
                      myCellInvoiceArray[2]?.ytd,
                      classes,
                      myCellInvoiceArray[2]?.type,
                    ),
              ytd1: myCellInvoiceArray[2]?.ytd,
              vectorranking: myCellInvoiceArray[2]?.vectorRank,

              bestcell:
                myCellInvoiceArray[2]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[2]?.bestCell, classes)
                  : formatToNumber(
                      myCellInvoiceArray[2]?.bestCell,
                      classes,
                      myCellInvoiceArray[2]?.type,
                    ),
              bestCell1: myCellInvoiceArray[2]?.bestCell,
              previousyear:
                myCellInvoiceArray[2]?.type == null
                  ? formatToCurrency(myCellInvoiceArray[2]?.prevYear, classes)
                  : formatToNumber(
                      myCellInvoiceArray[2]?.prevYear,
                      classes,
                      myCellInvoiceArray[2]?.type,
                    ),
              previousYear1: myCellInvoiceArray[2]?.prevYear,
            },

            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Current (Not Yet Due)"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd: (() => {
                // Check pastDueInvoicesObject first
                const pastDueValue = pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year(),
                  )?.current;

                // Check cellReportData as fallback
                let cellReportDataCopy = cellReportData;
                let cellReportValue = cellReportDataCopy[loggedInUserData?.cellId]?.currentAmount;
                if (pastDueValue !== undefined) {
                  return formatToCurrency(pastDueValue, classes) || 'N/A';
                } else if (cellReportValue !== undefined) {
                  return formatToCurrency(cellReportValue, classes) || 'N/A';
                } else {
                  return 'N/A';
                }
              })(),

              vectorranking: (() => {
                let cellReportDataCopy = cellReportData;

                // Convert object to array and sort by overallOutstanding
                if (
                  cellReportDataCopy &&
                  typeof cellReportDataCopy === 'object' &&
                  !Array.isArray(cellReportDataCopy)
                ) {
                  // Convert object to array of objects with cellId as key
                  cellReportDataCopy = Object.keys(cellReportDataCopy).map((cellId) => ({
                    cellId: cellId,
                    ...cellReportDataCopy[cellId],
                  }));
                }

                // Now sort the array
                if (Array.isArray(cellReportDataCopy)) {
                  cellReportDataCopy.sort((a, b) => {
                    return (
                      (parseFloat(b?.currentAmount) || 0) - (parseFloat(a?.currentAmount) || 0)
                    );
                  });
                } else {
                  cellReportDataCopy = []; // Set to empty array as fallback
                }

                let indexOfMyCell =
                  cellReportDataCopy.findIndex((item) => item.cellId === loggedInUserData?.cellId) +
                  1;
                const currentYear = moment().year();
                let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                // Filter the array with the condition
                const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                  (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                );

                // Sort the filtered array in descending order based on the 'current' property
                const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                  return (parseFloat(b?.current) || 0) - (parseFloat(a?.current) || 0);
                });

                // Find the index of the object that matches the condition
                const index = sortedPastDueInvoices.findIndex(
                  (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                );

                return loggedInUserData?.country?.countryTitle == 'United States'
                  ? index === -1
                    ? 'N/A'
                    : index + 1
                  : indexOfMyCell;
              })(),

              bestcell: (() => {
                // Check if user is from United States
                if (loggedInUserData?.country?.countryTitle === 'United States') {
                  // Show highest totalDue from pastDueInvoicesObject
                  return formatToCurrency(
                    pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                      const currentYear = moment().year();
                      const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                      if (reportYear === currentYear) {
                        const currentValue = parseFloat(currentObj?.current) || 0;
                        const maxValue = parseFloat(maxObj?.current) || 0;
                        return currentValue > maxValue ? currentObj : maxObj;
                      }
                      return maxObj;
                    }, {})?.current,
                  );
                } else {
                  // Show highest latePastDue from cellReportData
                  let cellDataArray = cellReportData;

                  // Convert object to array if needed
                  if (
                    cellDataArray &&
                    typeof cellDataArray === 'object' &&
                    !Array.isArray(cellDataArray)
                  ) {
                    cellDataArray = Object.keys(cellDataArray).map((cellId) => ({
                      cellId: cellId,
                      ...cellDataArray[cellId],
                    }));
                  }

                  if (Array.isArray(cellDataArray) && cellDataArray.length > 0) {
                    const maxCell = cellDataArray.reduce((maxObj, currentObj) => {
                      const currentValue = parseFloat(currentObj?.currentAmount) || 0;
                      const maxValue = parseFloat(maxObj?.currentAmount) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }, {});
                    return formatToCurrency(maxCell?.currentAmount);
                  } else {
                    return 'N/A';
                  }
                }
              })(),
              previousyear:
                pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) =>
                      new Date(pi?.reportPeriod).getFullYear() ==
                      moment().subtract(1, 'year').year(),
                  )?.current === undefined
                  ? 'N/A'
                  : formatToCurrency(
                      pastDueInvoicesObject
                        .filter(
                          (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                        )
                        .find(
                          (pi) =>
                            new Date(pi?.reportPeriod).getFullYear() ==
                            moment().subtract(1, 'year').year(),
                        )?.current,
                      classes,
                    ) || 'N/A',
              previousYear1: pastDueInvoicesObject
                .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                .find(
                  (pi) =>
                    new Date(pi?.reportPeriod).getFullYear() == moment().subtract(1, 'year').year(),
                )?.current,
            },
            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="1 - 30 Days Past Due Amount"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),
              ytd: (() => {
                // Check pastDueInvoicesObject first
                const pastDueValue = pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year(),
                  )?.oneToThirty;

                // Check cellReportData as fallback
                let cellReportDataCopy = cellReportData;
                let cellReportValue = cellReportDataCopy[loggedInUserData?.cellId]?.earlyPastDue;
                if (pastDueValue !== undefined) {
                  return formatToCurrency(pastDueValue, classes) || 'N/A';
                } else if (cellReportValue !== undefined) {
                  return formatToCurrency(cellReportValue, classes) || 'N/A';
                } else {
                  return 'N/A';
                }
              })(),

              vectorranking: (() => {
                let cellReportDataCopy = cellReportData;

                // Convert object to array and sort by overallOutstanding
                if (
                  cellReportDataCopy &&
                  typeof cellReportDataCopy === 'object' &&
                  !Array.isArray(cellReportDataCopy)
                ) {
                  // Convert object to array of objects with cellId as key
                  cellReportDataCopy = Object.keys(cellReportDataCopy).map((cellId) => ({
                    cellId: cellId,
                    ...cellReportDataCopy[cellId],
                  }));
                }

                // Now sort the array
                if (Array.isArray(cellReportDataCopy)) {
                  cellReportDataCopy.sort((a, b) => {
                    return (parseFloat(b?.earlyPastDue) || 0) - (parseFloat(a?.earlyPastDue) || 0);
                  });
                } else {
                  cellReportDataCopy = []; // Set to empty array as fallback
                }

                let indexOfMyCell =
                  cellReportDataCopy.findIndex((item) => item.cellId === loggedInUserData?.cellId) +
                  1;
                const currentYear = moment().year();
                let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                // Filter the array with the condition
                const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                  (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                );

                // Sort the filtered array in descending order based on the 'current' property
                const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                  return (parseFloat(b?.oneToThirty) || 0) - (parseFloat(a?.oneToThirty) || 0);
                });

                // Find the index of the object that matches the condition
                const index = sortedPastDueInvoices.findIndex(
                  (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                );

                return loggedInUserData?.country?.countryTitle == 'United States'
                  ? index === -1
                    ? 'N/A'
                    : index + 1
                  : indexOfMyCell;
              })(),

              bestcell: (() => {
                // Check if user is from United States
                if (loggedInUserData?.country?.countryTitle === 'United States') {
                  // Show highest totalDue from pastDueInvoicesObject
                  return formatToCurrency(
                    pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                      const currentYear = moment().year();
                      const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                      if (reportYear === currentYear) {
                        const currentValue = parseFloat(currentObj?.oneToThirty) || 0;
                        const maxValue = parseFloat(maxObj?.oneToThirty) || 0;
                        return currentValue > maxValue ? currentObj : maxObj;
                      }
                      return maxObj;
                    }, {})?.oneToThirty,
                  );
                } else {
                  // Show highest latePastDue from cellReportData
                  let cellDataArray = cellReportData;

                  // Convert object to array if needed
                  if (
                    cellDataArray &&
                    typeof cellDataArray === 'object' &&
                    !Array.isArray(cellDataArray)
                  ) {
                    cellDataArray = Object.keys(cellDataArray).map((cellId) => ({
                      cellId: cellId,
                      ...cellDataArray[cellId],
                    }));
                  }

                  if (Array.isArray(cellDataArray) && cellDataArray.length > 0) {
                    const maxCell = cellDataArray.reduce((maxObj, currentObj) => {
                      const currentValue = parseFloat(currentObj?.earlyPastDue) || 0;
                      const maxValue = parseFloat(maxObj?.earlyPastDue) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }, {});
                    return formatToCurrency(maxCell?.earlyPastDue);
                  } else {
                    return 'N/A';
                  }
                }
              })(),
              previousyear:
                pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) =>
                      new Date(pi?.reportPeriod).getFullYear() ==
                      moment().subtract(1, 'year').year(),
                  )?.oneToThirty === undefined
                  ? 'N/A'
                  : formatToCurrency(
                      pastDueInvoicesObject
                        .filter(
                          (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                        )
                        .find(
                          (pi) =>
                            new Date(pi?.reportPeriod).getFullYear() ==
                            moment().subtract(1, 'year').year(),
                        )?.oneToThirty,
                      classes,
                    ) || 'N/A',
              previousYear1: pastDueInvoicesObject
                .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                .find(
                  (pi) =>
                    new Date(pi?.reportPeriod).getFullYear() == moment().subtract(1, 'year').year(),
                )?.oneToThirty,
            },
            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="31+ Days Past Due amount"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),

              ytd: (() => {
                // Check pastDueInvoicesObject first
                const pastDueValue = pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year(),
                  )?.thirtyAndOver;

                // Check cellReportData as fallback
                let cellReportDataCopy = cellReportData;
                let cellReportValue = cellReportDataCopy[loggedInUserData?.cellId]?.latePastDue;
                if (pastDueValue !== undefined) {
                  return formatToCurrency(pastDueValue, classes) || 'N/A';
                } else if (cellReportValue !== undefined) {
                  return formatToCurrency(cellReportValue, classes) || 'N/A';
                } else {
                  return 'N/A';
                }
              })(),
              vectorranking: (() => {
                let cellReportDataCopy = cellReportData;

                // Convert object to array and sort by overallOutstanding
                if (
                  cellReportDataCopy &&
                  typeof cellReportDataCopy === 'object' &&
                  !Array.isArray(cellReportDataCopy)
                ) {
                  // Convert object to array of objects with cellId as key
                  cellReportDataCopy = Object.keys(cellReportDataCopy).map((cellId) => ({
                    cellId: cellId,
                    ...cellReportDataCopy[cellId],
                  }));
                }

                // Now sort the array
                if (Array.isArray(cellReportDataCopy)) {
                  cellReportDataCopy.sort((a, b) => {
                    return (parseFloat(b?.latePastDue) || 0) - (parseFloat(a?.latePastDue) || 0);
                  });
                } else {
                  cellReportDataCopy = []; // Set to empty array as fallback
                }

                let indexOfMyCell =
                  cellReportDataCopy.findIndex((item) => item.cellId === loggedInUserData?.cellId) +
                  1;
                const currentYear = moment().year();
                let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                // Filter the array with the condition
                const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                  (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                );

                // Sort the filtered array in descending order based on the 'current' property
                const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                  return (parseFloat(b?.thirtyAndOver) || 0) - (parseFloat(a?.thirtyAndOver) || 0);
                });

                // Find the index of the object that matches the condition
                const index = sortedPastDueInvoices.findIndex(
                  (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                );

                return loggedInUserData?.country?.countryTitle == 'United States'
                  ? index === -1
                    ? 'N/A'
                    : index + 1
                  : indexOfMyCell;
              })(),

              bestcell: (() => {
                // Check if user is from United States
                if (loggedInUserData?.country?.countryTitle === 'United States') {
                  // Show highest totalDue from pastDueInvoicesObject
                  return formatToCurrency(
                    pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                      const currentYear = moment().year();
                      const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                      if (reportYear === currentYear) {
                        const currentThirtyAndOver = parseFloat(currentObj?.thirtyAndOver) || 0;
                        const maxThirtyAndOver = parseFloat(maxObj?.thirtyAndOver) || 0;
                        return currentThirtyAndOver > maxThirtyAndOver ? currentObj : maxObj;
                      }
                      return maxObj;
                    }, {})?.thirtyAndOver,
                  );
                } else {
                  // Show highest latePastDue from cellReportData
                  let cellDataArray = cellReportData;

                  // Convert object to array if needed
                  if (
                    cellDataArray &&
                    typeof cellDataArray === 'object' &&
                    !Array.isArray(cellDataArray)
                  ) {
                    cellDataArray = Object.keys(cellDataArray).map((cellId) => ({
                      cellId: cellId,
                      ...cellDataArray[cellId],
                    }));
                  }

                  if (Array.isArray(cellDataArray) && cellDataArray.length > 0) {
                    const maxCell = cellDataArray.reduce((maxObj, currentObj) => {
                      const currentValue = parseFloat(currentObj?.latePastDue) || 0;
                      const maxValue = parseFloat(maxObj?.latePastDue) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }, {});
                    return formatToCurrency(maxCell?.latePastDue);
                  } else {
                    return 'N/A';
                  }
                }
              })(),

              previousyear:
                pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) =>
                      new Date(pi?.reportPeriod).getFullYear() ==
                      moment().subtract(1, 'year').year(),
                  )?.thirtyAndOver === undefined
                  ? 'N/A'
                  : formatToCurrency(
                      pastDueInvoicesObject
                        .filter(
                          (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                        )
                        .find(
                          (pi) =>
                            new Date(pi?.reportPeriod).getFullYear() ==
                            moment().subtract(1, 'year').year(),
                        )?.thirtyAndOver,
                      classes,
                    ) || 'N/A',
            },
            {
              cellf: (
                <InfoPopoverCommentsWrapper
                  dashboardComments={dashboardComments}
                  section="Overall Outstanding"
                  title={dashboardSectionText}
                  onCommentUpdate={onCommentUpdate}
                />
              ),

              ytd: (() => {
                // Check pastDueInvoicesObject first
                const pastDueValue = pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year(),
                  )?.totalDue;

                // Check cellReportData as fallback
                let cellReportDataCopy = cellReportData;
                let cellReportValue =
                  cellReportDataCopy[loggedInUserData?.cellId]?.overallOutstanding;
                if (pastDueValue !== undefined) {
                  return formatToCurrency(pastDueValue, classes) || 'N/A';
                } else if (cellReportValue !== undefined) {
                  return formatToCurrency(cellReportValue, classes) || 'N/A';
                } else {
                  return 'N/A';
                }
              })(),
              vectorranking: (() => {
                const currentYear = moment().year();
                let cellReportDataCopy = cellReportData;

                // Convert object to array and sort by overallOutstanding
                if (
                  cellReportDataCopy &&
                  typeof cellReportDataCopy === 'object' &&
                  !Array.isArray(cellReportDataCopy)
                ) {
                  // Convert object to array of objects with cellId as key
                  cellReportDataCopy = Object.keys(cellReportDataCopy).map((cellId) => ({
                    cellId: cellId,
                    ...cellReportDataCopy[cellId],
                  }));
                }

                // Now sort the array
                if (Array.isArray(cellReportDataCopy)) {
                  cellReportDataCopy.sort((a, b) => {
                    return (
                      (parseFloat(b?.overallOutstanding) || 0) -
                      (parseFloat(a?.overallOutstanding) || 0)
                    );
                  });
                } else {
                  cellReportDataCopy = []; // Set to empty array as fallback
                }

                let indexOfMyCell =
                  cellReportDataCopy.findIndex((item) => item.cellId === loggedInUserData?.cellId) +
                  1;
                let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                // Filter the array with the condition
                const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                  (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                );

                // Sort the filtered array in descending order based on the 'current' property
                const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                  return (parseFloat(b?.totalDue) || 0) - (parseFloat(a?.totalDue) || 0);
                });

                // Find the index of the object that matches the condition
                const index = sortedPastDueInvoices.findIndex(
                  (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                );

                return loggedInUserData?.country?.countryTitle == 'United States'
                  ? index === -1
                    ? 'N/A'
                    : index + 1
                  : indexOfMyCell;
              })(),

              bestcell: (() => {
                // Check if user is from United States
                if (loggedInUserData?.country?.countryTitle === 'United States') {
                  // Show highest totalDue from pastDueInvoicesObject
                  return formatToCurrency(
                    pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                      const currentYear = moment().year();
                      const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                      if (reportYear === currentYear) {
                        const currentValue = parseFloat(currentObj?.totalDue) || 0;
                        const maxValue = parseFloat(maxObj?.totalDue) || 0;
                        return currentValue > maxValue ? currentObj : maxObj;
                      }
                      return maxObj;
                    }, {})?.totalDue,
                  );
                } else {
                  // Show highest overallOutstanding from cellReportData
                  let cellDataArray = cellReportData;

                  // Convert object to array if needed
                  if (
                    cellDataArray &&
                    typeof cellDataArray === 'object' &&
                    !Array.isArray(cellDataArray)
                  ) {
                    cellDataArray = Object.keys(cellDataArray).map((cellId) => ({
                      cellId: cellId,
                      ...cellDataArray[cellId],
                    }));
                  }

                  if (Array.isArray(cellDataArray) && cellDataArray.length > 0) {
                    const maxCell = cellDataArray.reduce((maxObj, currentObj) => {
                      const currentValue = parseFloat(currentObj?.overallOutstanding) || 0;
                      const maxValue = parseFloat(maxObj?.overallOutstanding) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }, {});
                    return formatToCurrency(maxCell?.overallOutstanding);
                  } else {
                    return 'N/A';
                  }
                }
              })(),

              previousyear:
                pastDueInvoicesObject
                  .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                  .find(
                    (pi) =>
                      new Date(pi?.reportPeriod).getFullYear() ==
                      moment().subtract(1, 'year').year(),
                  )?.totalDue === undefined
                  ? 'N/A'
                  : formatToCurrency(
                      pastDueInvoicesObject
                        .filter(
                          (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                        )
                        .find(
                          (pi) =>
                            new Date(pi?.reportPeriod).getFullYear() ==
                            moment().subtract(1, 'year').year(),
                        )?.totalDue,
                      classes,
                    ) || 'N/A',
            },
          ]}
        />
      </Box>
    </>
  );
};

export default SummaryInvoiceByCell;
